import loadingAnim1 from "../../images/loading.svg";
import loadingAnim2 from "../../images/blocks-shuffle-4.svg";
import { useEffect, useState } from "react";

export default function LoadingExtended({
  texts,
  little,
  variant = 0,
}: {
  texts: String[] | React.ReactElement[];
  little?: boolean;
  variant?: number;
}) {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () =>
        setStage((prev: number) => {
          const res = prev < texts?.length ? prev + 1 : 0;
          return res;
        }),
      2000,
    );
    return () => clearInterval(interval);
  }, []);

  const currentText = texts?.[stage];

  return (
    <div className="loading" style={{ padding: "33px" }}>
      <div>
        <img
          src={!variant ? loadingAnim1 : loadingAnim2}
          style={
            little
              ? {
                  boxShadow: "0 0 5px orange",
                  borderRadius: "50%",
                  width: "18px",
                }
              : variant === 1
                ? {
                    width: "42px",
                    padding: "13px",
                  }
                : {}
          }
        />
        <div style={{ fontSize: "16px" }}>{currentText}</div>
      </div>
    </div>
  );
}
